export const APPLICATION_AVAILABLE_REQUEST = 'APPLICATION_AVAILABLE_REQUEST';
export const APPLICATION_AVAILABLE_SUCCESS = 'APPLICATION_AVAILABLE_SUCCESS';
export const APPLICATION_AVAILABLE_FAIL = 'APPLICATION_AVAILABLE_FAIL';
